$(document).ready(function () {
  $(".cart__qty-input").on("input", function () {
    // Print entered value in a div box

    var variantt = $(this).data("variant-id");
    var variantt1 = variantt.substr(0, variantt.indexOf(":"));

    console.log(variantt1);
    var qty = $(this).val(),
      // this_item = $(this).closest(item),
      variant_id = variantt1,
      subtotal = $("#revy-cart-subtotal-price").find("span.money");
    wholeTotal = $(".cart_whole_totle").find("span.money");
    this_item_total = $(this)
      .closest("tr")
      .find(".item_total_price span.money");

    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: {
        quantity: qty,
        id: variant_id,
      },
      success: function (cart) {
        if (qty == 0) {
          this_item.remove();
        } else {
          $.each(cart.items, function (index, row) {
            console.log(cart.items);
            if (variant_id == row.variant_id)
              this_item_total.html(
                "$" + parseFloat(row.line_price / 100).toFixed(2)
              );
          });
        }
        subtotal.html("$" + parseFloat(cart.total_price / 100).toFixed(2));
        wholeTotal.html("$" + parseFloat(cart.total_price / 100).toFixed(2));

        if ($(".progress-cart_total").length) {
            let cartTotal = parseFloat(cart.total_price / 100);
            let toThreshold = (devsm.shipping_threshold - cartTotal).toFixed(2);
            console.log(devsm.shipping_threshold_msg)
            
            let priceinPerc = (cartTotal * 100 / devsm.shipping_threshold).toFixed(0);
            priceinPerc = priceinPerc > 100 ? 100 : priceinPerc;
            $(".free-shipping-progress-inner").css("width", priceinPerc + "%");
            if (priceinPerc >= 100) {
                $(".progress-cart_total").text(devsm.shipping_success_message);
            } else {
                $(".progress-cart_total").text(devsm.shipping_threshold_msg.replace("$amt", toThreshold));
            }
        }
      },
      error: function (response) {
        alert(response);
      },
    });
  });
});
